import React from "react";
import { Typography, Divider } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./OrderTracker.css"; // Import the CSS file

import { useMediaQuery } from "@mui/material";

const OrderTracker = ({ orderData }) => {
    const { order, details } = orderData;
    const status = order.order_status; // Assuming status is one of "Placed", "Pending", "Shipped", "Delivered", "Invoiced"

    // Define the statuses in an array for easy mapping
    const statusList = [
		{ label: "Quote Placed", status: "Pending", date: new Date(order.order_created_date).toLocaleDateString() },
		{
			label: "Order confirmed",
			status: "Confirmed",
			date: "TBD",
		},
		// { label: "Order Shipped", status: "Shipped", date: "TBD" },
		// { label: "Order Delivered", status: "Delivered", date: "TBD" },
		// { label: "Invoiced", status: "Invoiced", date: "TBD" },
	];

	const isMobile = useMediaQuery("(max-width: 768px)");

	return (
		<>
			<div className="order-container">
				<div className="order-card">
					<div className="order-card-content">
						<div className="order-header">
							<div className="order-info">
								<Typography variant="h6" component="div">
									<b>
										Your{" "}
										{details.freight_number !== "" ? `Order is ${status}` : `Quote is ${status}`}!
									</b>
								</Typography>
								<Typography variant="body2" color="text.secondary" fontWeight="bold">
									Date: {new Date(order.order_created_date).toLocaleDateString()} | Quote Number:{" "}
									{order.order_number} | Order Number:{" "}
									{details.freight_number !== "" ? details.freight_number : "N/A"}
								</Typography>
							</div>
						</div>
						<Divider className="otdivider" />

						{!isMobile ? (
							<div className="tracker-container" style={{ width: "70%", margin: "0 auto" }}>
								<div className="order-tracking">
									{statusList.map((step, index) => {
										const isCurrentStatus = status === step.status; // Is this the current status?
										const isNotComplete = index > statusList.findIndex((s) => s.status === status); // Check if this step is after the current status

										return (
											<React.Fragment key={step.status}>
												<div className="dot-container">
													{isCurrentStatus && <CheckCircleIcon className="check-icon" />}
													{!isCurrentStatus && (
														<div
															className={`dot ${
																isNotComplete ? "notcomplete" : ""
															}`}></div>
													)}
												</div>
												{/* Line between steps, apply 'notcomplete' to the track line if needed */}
												{index < statusList.length - 1 && (
													<div
														className={`track-line ${
															isNotComplete ? "notcomplete" : ""
														}`}></div>
												)}
											</React.Fragment>
										);
									})}
								</div>

								<div className="order-status">
									{statusList.map((step) => (
										<div key={step.status} className="status-item">
											<Typography>{step.date}</Typography>
											<Typography>{step.label}</Typography>
										</div>
									))}
								</div>
							</div>
						) : (
							<div className="tracker-container">
								<div className="order-tracking">
									{statusList.map((step, index) => {
										const isCurrentStatus = status === step.status; // Is this the current status?
										const isNotComplete = index > statusList.findIndex((s) => s.status === status); // Check if this step is after the current status

										return (
											<React.Fragment key={step.status}>
												<div className="dot-container">
													{isCurrentStatus && <CheckCircleIcon className="check-icon" />}
													{!isCurrentStatus && (
														<div
															className={`dot ${
																isNotComplete ? "notcomplete" : ""
															}`}></div>
													)}
												</div>
												{/* Line between steps, apply 'notcomplete' to the track line if needed */}
												{index < statusList.length - 1 && (
													<div
														className={`track-line ${
															isNotComplete ? "notcomplete" : ""
														}`}></div>
												)}
											</React.Fragment>
										);
									})}
								</div>

								<div className="order-status">
									{statusList.map((step) => (
										<div key={step.status} className="status-item">
											<Typography>{step.date}</Typography>
											<Typography>{step.label}</Typography>
										</div>
									))}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default OrderTracker;
